export default __webpack_public_path__ + "static/media/c001-student-8.34c27195.jpg";